import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="py-24 bg-parchment-dark relative" data-id="element-32">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-33">
        <div className="bg-parchment-light rounded-3xl p-8 md:p-12 shadow-xl shadow-brown-dark/5 border border-gold/10 relative overflow-hidden" data-id="element-34">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold/30 rounded-tl-3xl m-4" data-id="element-35" />
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold/30 rounded-br-3xl m-4" data-id="element-36" />

          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-37">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="w-40 h-40 md:w-56 md:h-56 shrink-0 rounded-full border-4 border-parchment-dark shadow-inner overflow-hidden bg-forest-dark flex items-center justify-center relative" data-id="element-38">
              {/* Placeholder for author image - using a stylized initial since we don't have a photo */}
              <div className="absolute inset-0 bg-gradient-to-br from-forest-light to-forest-dark opacity-80" data-id="element-39" />
              <span className="font-display text-6xl md:text-8xl text-gold/80 relative z-10" data-id="element-40">
                R
              </span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-41">
              <h2 className="font-display text-3xl md:text-4xl text-forest-dark font-bold mb-2" data-id="element-42">
                Rosana G.
              </h2>
              <p className="text-gold-dark font-medium tracking-wide uppercase text-sm mb-6" data-id="element-43">
                Autora & Divulgadora
              </p>
              <div className="space-y-4 text-brown-light leading-relaxed" data-id="element-44">
                <p data-id="element-45">
                  Dedicada a la difusión y enseñanza de las Cinco Leyes
                  Biológicas, Rosana G. ha creado esta obra con el propósito de
                  acercar este conocimiento transformador a todas las personas
                  dispuestas a tomar las riendas de su salud.
                </p>
                <p data-id="element-46">
                  Su enfoque claro, compasivo y estructurado permite que
                  conceptos médicos y biológicos complejos sean accesibles para
                  cualquier lector, facilitando un verdadero despertar de la
                  conciencia.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}